const DRAFT = { id: 'DRAFT', name: 'Draf' }
const SCHEDULED = { id: 'SCHEDULED', name: 'Dijadwalkan' }
const STARTED = { id: 'STARTED', name: 'Dijalankan' }
const ENDED = { id: 'ENDED', name: 'Selesai' }
const CANCELED = { id: 'CANCELED', name: 'Dibatalkan' }

const status = {
  DRAFT,
  SCHEDULED,
  STARTED,
  ENDED,
  CANCELED,
}

export default status
